/* SuprPetrix — Judge.me 评论图片优化
 * 将 imgix URL 的 w=1024 降为 w=400，节省 ~1.1MB 首页加载 */
(function () {
  function optimizeJudgeMeImages() {
    document.querySelectorAll('img[src*="judgeme.imgix.net"]').forEach(function (img) {
      var src = img.getAttribute('src');
      if (src && src.indexOf('w=1024') !== -1) {
        img.setAttribute('src', src.replace('w=1024', 'w=400'));
      }
      if (!img.getAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  }

  // 首次执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeJudgeMeImages);
  } else {
    optimizeJudgeMeImages();
  }

  // 监听动态加载（Judge.me 轮播懒加载新图片）
  var observer = new MutationObserver(function (mutations) {
    var hasNewImages = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (hasNewImages) optimizeJudgeMeImages();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
